import React from 'react'

function PermissionDeniedCom() {
  return (
    <>
    
      <div className="row_bg">
        <div className='error_ttl'>Error</div> 
        <div className='error_content'>“Sorry, You Are Not Allowed to Access This Page” </div>
     
    </div> 

    </>
  )
}

export default PermissionDeniedCom
